import React, { useState } from 'react'
import { Icon } from '../../../components/Icon'
import PdfViewer from '../../../components/UI/PdfViewer'
import { lastStr } from '../../policy/utils'

const UserDataContent = ({
  content,
}: {
  content?: Record<string, string | boolean>[]
}) => {
  const [isOpenPdfViewer, setIsOpenPdfViewer] = useState<boolean>(false)
  const [pdfUrl, setPdfUrl] = useState('')
  return (
    <>
      {content?.map(
        (item: { [key: string]: string | boolean }, index: number) => {
          return (
            <React.Fragment key={index}>
              <div className="w-auto">
                <div className="flex h-fit">
                  <div
                    className={`bg-gray2 h-auto mt-[1px] py-4 px-4 w-60 ${index === 0 ? 'rounded-tl-xl' : ' rounded-none'} ${index === content.length - 1 ? 'rounded-bl-xl' : ' rounded-none'}`}
                  >
                    <p className="text-sm font-semibold leading-6 text-text5">
                      {Object.keys(item)[0]}
                    </p>
                  </div>
                  <div
                    className={`bg-gray1 mt-[1px] ml-[1px] flex flex-1 items-center py-3 px-4 ${index === 0 ? 'rounded-tr-xl' : ' rounded-none'} ${index === content.length - 1 ? 'rounded-br-xl' : 'rounded-none'}`}
                  >
                    {item?.pdf == true ? (
                      <div
                        onClick={() => {
                          setPdfUrl(`${item?.value}`)
                          setIsOpenPdfViewer(true)
                        }}
                        className="py-3 px-4 flex gap-2 items-center bg-white rounded-xl"
                      >
                        <Icon
                          name="IconFile"
                          width={16}
                          height={16}
                          strokeWidth={1.5}
                          stroke={'#02698C'}
                        />
                        <p className="text-sm font-semibold leading-6 text-bluishGreen flex-1 pr-6">
                          {lastStr(`${item?.value}`)}{' '}
                          <span className="text-xs font-medium leading-5 text-text3 ml-[2px]">
                            {item?.size}
                          </span>
                        </p>
                        <Icon
                          name="IconDownloadCloud"
                          width={16}
                          height={16}
                          strokeWidth={1}
                          stroke={'#67A5B9'}
                        />
                      </div>
                    ) : Object.values(item).includes('Not Specified') ? (
                      <p className="text-sm font-normal leading-6 text-text3">
                        {Object.values(item)}
                      </p>
                    ) : (
                      <p className="text-sm font-semibold leading-6 text-text5">
                        {Object.values(item)}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </React.Fragment>
          )
        }
      )}
      <PdfViewer
        isOpen={isOpenPdfViewer}
        onClose={() => {
          setIsOpenPdfViewer(false)
        }}
        url={pdfUrl}
        title="PDF Viewer"
      />
    </>
  )
}

export default UserDataContent
